import { useCallback } from 'react';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const useNavigateToFinalDeleteStep = () => {
    const navigation = useMainStackNavigation();
    const emmaProStatus = useAppSelector((store) => store.user.user.emmaProStatus);
    const navigateToFinalDeleteStep = useCallback(() => {
        if (emmaProStatus.autoRenewing &&
            emmaProStatus.active &&
            !(emmaProStatus.reverseTrial?.active &&
                emmaProStatus.reverseTrial?.expiresOn)) {
            navigation.navigateDeprecated('DeleteActivePremiumSubscription');
        }
        else {
            navigation.navigateDeprecated('DeleteSuccess');
        }
    }, [
        emmaProStatus.active,
        emmaProStatus.autoRenewing,
        emmaProStatus.reverseTrial?.active,
        emmaProStatus.reverseTrial?.expiresOn,
    ]);
    return navigateToFinalDeleteStep;
};
export default useNavigateToFinalDeleteStep;
